import { render, staticRenderFns } from "./MyCustomer.vue?vue&type=template&id=6d4d933c&scoped=true"
import script from "./MyCustomer.vue?vue&type=script&lang=js"
export * from "./MyCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d933c",
  null
  
)

export default component.exports